import React from 'react'
import { connect } from 'react-redux'
import { Table, Thead, Th, Tr, Td } from 'components/reactable'
import {
    setOpenedSubmenu, fetchClientClaims, fetchClientContract, setClientSubModule,
    setBrNr, fetchClientOptionsDict, resetClaimWizard
} from 'state/actions'
import { getTheLanguageCodeByAnyLanguageOnAnyLanguage } from 'lib/helpers'
import styles from './clientContractsZoom.scss'
import Uploader from '../uploader'
import KeyValue from '../KeyValue'
import moment from 'moment'
import { dateFormatter } from 'lib/helpers'
import EmailButton from '../emailSender/emailButton'
import nesProp from 'nested-property'
import {
    CONTRACT_PRE_MANDATE, CONTRACT_PRE_PROPOSAL, UPLOADER_STATE_NEW_POLICY,
    UPLOADER_STATE_POLICY_FILE, DS_MODULE_CLIENT_CONTRACT, DS_MODULE_CLIENT_CONTRACT_PREM
} from 'state/constants'
import i18n from 'lib/i18n'
import MifidButton from '../DSDocuments/mifidButton'
import ClaimWizardButton from '../ClaimsWizard/ClaimWizardButton'

const _ = i18n('clientContractsZoom')

const Risk = ({ data }) => {
    return (
        <div className={styles.clientsTableContainer}>
            <div className={styles.riskDescriptionContainer}>
                <div className={styles.riskDescLabel}>
                    <p>{_('description')}</p>
                </div>
                <div className={styles.riskDesc}>
                    <p>{data.riskDescription}</p>
                </div>
            </div>
            <Table
                className={styles.table}
                topPagination={false}
                bottomPagination={false}
                sortable={[
                    "product",
                    "option",
                ]}
            >
                <Thead>
                    <Th column="product">
                        <strong>{_('product')}</strong>
                    </Th>
                    <Th column="option">
                        <strong>{_('option')}</strong>
                    </Th>
                </Thead>
                {data.products &&
                    data.products.map((item, key) =>
                        <Tr className="centered" key={key}>
                            <Td column="product">{item.product}</Td>
                            <Td column="option">{item.option}</Td>
                        </Tr>
                    )
                }
            </Table>
        </div>
    )
}

/**
 * This function render the data for the qualification column in the claims result table.
 * @param {object} main - thi is the claims record main property, what contains the qualification values
 */
const formatQualification = (main) => {
    return (
        <span>
            <span>
                {main.qualification}
            </span>
            {main.subQualification &&
                <span>
                    ,<br />
                    {main.subQualification}
                </span>
            }
        </span>)
}

const Claims = ({ data, zoomTo }) => {
    const formattedData = data.map(item => ({
        ...item.claimMain,
        claimDate: moment(item.claimMain.claimDate).format("DD-MM-YYYY"),
        creationDate: moment(item.claimMain.creationDate).format("DD-MM-YYYY"),
    }))

    return (
        <div className={styles.clientsTableContainer}>
            <div className={styles.descriptionContainer}>
                <div className={styles.descLabel}>
                    <p>{_('claimsHeader')}</p>
                </div>
            </div>
            <Table
                className={styles.table}
                topPagination={false}
                bottomPagination={false}
                itemsPerPage={10}
                sortable={[
                    { column: 'claimDate', sortFunction: 'Date' },
                    { column: 'creationDate', sortFunction: 'Date' },
                    'claimNumber',
                    'claimsManager',
                    'qualification',
                    'state',
                ]}
                defaultSort={{
                    column: 'creationDate',
                    direction: 'desc',
                }}
            >
                <Thead>
                    <Th column="claimDate">
                        <strong>{_('claimDate')}</strong>
                    </Th>
                    <Th column="creationDate">
                        <strong>{_('creationDate')}</strong>
                    </Th>
                    <Th column="claimNumber">
                        <strong>{_('claimNumber')}</strong>
                    </Th>
                    <Th column="claimsManager">
                        <strong>{_('claimsManager')}</strong>
                    </Th>
                    <Th column="qualification">
                        <strong>{_('qualification')}</strong>
                    </Th>
                    <Th column="state">
                        <strong>{_('state')}</strong>
                    </Th>
                </Thead>
                {formattedData.length > 0 && formattedData.map((item, key) =>
                    <Tr className="clickable centered" onClick={() => zoomTo(item.claimId)} key={key}>
                        <Td column="claimDate" data={dateFormatter(item.claimDate)} />
                        <Td column="creationDate" data={dateFormatter(item.creationDate)} />
                        <Td column="claimNumber">{item.claimNumber}</Td>
                        <Td column="claimsManager">{item.claimsManager}</Td>
                        <Td column="qualification" data={formatQualification(item)} value={item.qualification + " " + item.subQualification} />
                        <Td column="state">{item.state}</Td>
                    </Tr>
                )
                }
            </Table>
        </div>
    )
}

@connect((state, props) => {
    const { contract, clientData } = props
    const clientId = state.app.opened
    const clientClaims = state.clients.claims[clientId]
    const claims = clientClaims && clientClaims.filter(item => (item.claimMain.contractNumber === contract.contractNumber)) || []
    const clientAccess = nesProp.get(state, "app.security.actions")
    const EmailTemplateRelations = state.app.security.EmailTemplateRelations
    const brNr = state.app.brNr
    const createContractState = state.clients.createContractState
    let canCreateMifid = false
    const selectedTicketDocuments = nesProp.get(state, "clients.initialArguments.selectedTicketDocuments")
    const ticketDocuments = nesProp.get(state, "clients.initialArguments.ticketDocuments")
    const ticketId = nesProp.get(state, "clients.initialArguments.ticketId")
    const emailAttachmentTicketDocuments = nesProp.get(state, "clients.initialArguments.emailAttachmentTicketDocuments")
    const claimStatus = state.claimWizard.claimData ? state.claimWizard.claimData.claimStatus : null;

    clientAccess.map((item, key) => {
        if (item.actionName == 'createmifid') {
            canCreateMifid = item.actionAllowed === "true" ? true : false
        }
    })


    return {
        clientId,
        claims,
        EmailTemplateRelations,
        clientAccess, clientData, brNr,
        clientOptionsDict: state.client.clientOptionsDict,
        appLanguage: state.app.lang,
        office: state.office,
        canCreateMifid,
        createContractState,
        ticketDocuments,
        selectedTicketDocuments,
        ticketId,
        emailAttachmentTicketDocuments,
        claimStatus
    }
})
export default class ClientContractsZoom extends React.Component {
    static propTypes = {
        dispatch: React.PropTypes.func.isRequired,
        contractId: React.PropTypes.string.isRequired,
        clientId: React.PropTypes.string.isRequired,
        clientContract: React.PropTypes.object,
        clientData: React.PropTypes.object,
        allClaims: React.PropTypes.array,
        clientOptionsDict: React.PropTypes.object,
        claimStatus: React.PropTypes.string
    }

    /**
     * Constructor: initialize state etc.
     * @param {*} props
     */
    constructor(props) {
        super(props)
        let { clientOptionsDict } = props
        this.state = {
            clientOptionsDict,
            initializationCompleted: false, contractLoaded: false, claimLoaded: false,
            characteristicTypeDict: {}
        }
    }

    /**
     * Fetching clientContracts and clientClaims data from server and set the current brokerNumber
     */
    fetchData() {
        const { dispatch, contract, clientId, brNr } = this.props

        // if we have contract id we can get the contract details to know the related brokerNumber
        if (contract && contract.contractId) {
            dispatch(fetchClientContract(contract.contractId)).then(() => {
                this.setState({ contractLoaded: true })
            })
        } else {
            this.setState({ contractLoaded: true })
        }

        // using the clientId trigger the fetchClientClaims to know claims managers email addresses and languages
        if (clientId) {
            dispatch(fetchClientClaims(clientId)).then(() => {
                this.setState({ claimLoaded: true })
            })
        } else {
            this.setState({ claimLoaded: true })
        }
    }

    /**
     * Triggered before update the module.
     * @param {object} nextProps
     * @param {object} nextState
     */
    componentWillUpdate(nextProps, nextState) {
        if (nextState.claimLoaded && nextState.contractLoaded && !nextState.initializationCompleted) {
            this.setState({ initializationCompleted: true })
        }
    }

    componentDidMount() {
        this.fetchData()

        const { dispatch, clientOptionsDict, createContractState } = this.props

        if (!clientOptionsDict || Object.keys(clientOptionsDict).length == 0) {
            dispatch(fetchClientOptionsDict())
                .then((dictionary) => {
                    this.setClientOptionsDict(dictionary)
                })
        } else {
            if (!this.state.clientOptionsDict) {
                this.setClientOptionsDict(clientOptionsDict)
            }
        }

        // // set the contract creation state in module state, to keep it
        // this.setState({createContractState: createContractState})
    }

    async componentWillUnmount () {
        const { dispatch } = this.props
        await dispatch(resetClaimWizard())
    }

    // /**
    //  * This will be call always when receive props
    //  * @param {*} nextProps
    //  */
    // componentWillReceiveProps(nextProps) {
    //     const {dispatch, createContractState} = this.props

    //     // get the create contract state in to the module state and remove it from store
    //     if (nextProps.createContractState !== createContractState && nextProps.createContractState) {
    //         this.setState({createContractState: createContractState})
    //         dispatch(setClientCreateContractState(''))
    //     }
    // }

    /**
     * Set client options dict in to the state
     * @param {object} dictionary - contains the dictionary
     */
    setClientOptionsDict(dictionary) {
        const { appLanguage } = this.props
        let characteristicTypeDict = this.processClientOptionsDictForCharacteristics(dictionary)

        this.setState({ clientOptionsDict: dictionary, characteristicTypeDict }, () => {
            this.forceUpdate()
        })
    }

    /**
     * This function returns the translated values for characteristicType
     * @param {object} dictionary - getListsLibrary result to get the translations
     */
    processClientOptionsDictForCharacteristics(dictionary) {
        let translations = {}

        if (!dictionary || !dictionary.KENMERKTYPE) {
            translations = dictionary.KENMERKTYPE

            // TODO if the type values are different like the indexes then we have to process and assign the values
            /* Object.keys(charaTypes).map((key) => {
                charaTypes[key]
            }) */
        }

        return translations
    }

    /**
     * This function return with values for email sender, collected from this module
     * depending on the current data structure.
     */
    collectVariableValues() {
        const { contract, clientData, clientId, office } = this.props
        const { clientOptionsDict } = this.state
        const { documents } = contract

        let emails = nesProp.get(clientData, "detail.emails")
        let clientName = nesProp.get(clientData, "main.name")

        // process email list to be digestible for email sender
        emails = emails.map((item) => ({
            referenceId: clientId,
            label: clientName,
            value: item.email,
            default: (item.default == "true" || item.default == true) ? true : false
        }))

        emails = emails.sort((item, item2) => {
            if (item.default && !item2.default) { return -1 }
            if (!item.default && item2.default) { return 1 }
            if ((item.default && item2.default) || (!item.default && !item2.default)) { return 0 }
        }) || []

        // decode language of client from a word to a code. Ex. "Nederlands" to "nl"
        let clientLanguage = nesProp.get(clientData, "detail.language") || ''
        clientLanguage = getTheLanguageCodeByAnyLanguageOnAnyLanguage(clientLanguage, clientOptionsDict)
        return {
            contractNumber: contract.contractNumber,

            clientDocuments: nesProp.get(clientData, "clientDocuments"),
            clientDocumentsType: 'client',
            clientDocumentsId: clientId,

            // new v6 mode
            claimDocuments: [],
            claimDocumentsType: "claim",
            claimDocumentsId: null,

            contractDocuments: documents,
            contractDocumentsType: "contract",
            contractDocumentsId: contract && contract.contractId,

            clientId: false,
            contractId: contract && contract.contractId,
            claimId: false,
            company: contract && contract.insuranceCompany,
            clientName: nesProp.get(clientData, "main.name"),
            clientNumber: nesProp.get(clientData, "main.clientNumber"),
            clientLanguage,
            clientEmails: emails,
            companyCancelMail: contract.companyCancelMail,

            brokerNumber: nesProp.get(contract, "details.brokerNumber"),

            // test line the next 2 remove
            brokersAvailableForThisUser: Object.keys(office && office.brokers || {}),
            contract: contract,
            clientData: nesProp.get(clientData, "main"),
            contractBranche: contract && contract.contractBranche,
        }

    }

    /**
     * This function transcode the contract state to an uploader state.
     * @param {string} createContractState contract state
     * @returns {string} uploader state
     */
    getUploadStateByContractState(createContractState) {
        let result = ''

        if (!createContractState) {
            return result
        }

        switch (createContractState) {
            case CONTRACT_PRE_PROPOSAL:
                result = UPLOADER_STATE_NEW_POLICY
                break
            //only case of prev the upload will be opened forcefully
            // case CONTRACT_PRE_MANDATE:
            //     result = UPLOADER_STATE_POLICY_FILE
            // break
        }

        return result
    }

    /**
     * This function returns a description about contract for uploader.
     * @param {string} createContractState contract state
     * @returns {string} uploader documents description
     */
    getUploadDescriptionByContractState(createContractState) {
        let result = ''

        if (!createContractState) {
            return result
        }

        switch (createContractState) {
            case CONTRACT_PRE_PROPOSAL:
                result = 'PREV'
                break
        }

        return result
    }

    /**
     * Resets ticket data from store in order to prevent multiple additions to dsWizzard
     */
    resetDataFromStoreOnCancel() {
        const { dispatch, ticketId, contractId } = this.props

        //reset aditional data fro tickets
        if (ticketId) {
            dispatch(setOpenedSubmenu(contractId, {}))
        }
    }

    render() {
        const { dispatch, claims, contract, clientAccess, canCreateMifid, clientId, contractId, createContractState, ticketId, ticketDocuments, selectedTicketDocuments, emailAttachmentTicketDocuments, claimStatus } = this.props
        const { clientOptionsDict, initializationCompleted, characteristicTypeDict } = this.state

        let contractIdForMifid = (contractId !== "undefined" && contractId) || contract.contractId

        // exit point for render if no data, try next time when data loaded
        if (!clientOptionsDict || !contract.details) { return <span>...</span> }

        const createmail = clientAccess &&
            clientAccess.filter((item) => (item.actionName == "createmail" && item.actionAllowed == "true")).length > 0
        const { details, documents } = contract || {}
        const c = contract || {}
        const columns = contract && [
            [
                { label: _('insuranceCompany'), value: c && c.insuranceCompany },
                { label: _('contractState'), value: c && c.contractState },
                { label: _('startDate'), value: details && moment(details.startDate).format('DD-MM-YYYY') },
                { label: _('collectType'), value: details && details.collectType },
                { label: _('bonusMalus'), value: details && details.bonusMalus },
                { label: _('premium'), value: details && _(details.unpaidInvoices) },
            ],
            [
                { label: _('brokerNumber'), value: details && details.brokerNumber },
                { label: _('dueDate'), value: details && moment(details.dueDate, 'MM-DD').format('DD-MM') },
                { label: _('endDate'), value: details && moment(details.endDate).format('DD-MM-YYYY') },
                { label: _('frequency'), value: details && details.frequency },
                { label: _('termination'), value: `${details && details.terminationType} ${details && details.terminationDate} ${details && details.terminationReason}` }
            ],
        ]

        // if have value then push
        if (details && details.characteristicValue) {

            // translator version
            /* columns[1].push({
                label: characteristicTypeDict && details && details.characteristicType && characteristicTypeDict[details.characteristicType] || _('characteristicValue'),
                value: details && details.characteristicValue || ""
            }) */

            columns[1].push({
                label: details && details.characteristicType || _('characteristicValue'),
                value: details && details.characteristicValue || ""
            })
        }

        const moduleKeyToSet = nesProp.get(this.props, "EmailTemplateRelations.EmailTemplateModules.clientsDetailsContract.value") || false

        // process the contract creation state to fetch an initial state for uploader module
        let uploadForceState = this.getUploadStateByContractState(createContractState)
        let uploadForceDescription = this.getUploadDescriptionByContractState(createContractState)
        const brokerNumber = nesProp.get(contract, "details.brokerNumber")

        return (
            <div className={styles.clientContractsZoomContainer}>
                <div className={styles.mainTitleDiv}>
                    <div className={styles.moduleControls}>
                        <div className={styles.buttonOrganizer}>
                            <div
                                onClick={() => {
                                    dispatch(setOpenedSubmenu())
                                }} className={styles.backToList}
                            >
                                {_('backToContracts')}
                            </div>
                            {createmail && initializationCompleted &&
                                <EmailButton moduleKeyToSet={moduleKeyToSet} moduleOptions={this.collectVariableValues()} />
                            }
                            {canCreateMifid &&
                                <div className={styles.wizardButtonCorrection}>
                                    <MifidButton
                                        moduleKeyToSet={createContractState && createContractState === CONTRACT_PRE_MANDATE ? DS_MODULE_CLIENT_CONTRACT_PREM : DS_MODULE_CLIENT_CONTRACT}
                                        clientId={clientId}
                                        contractId={contractIdForMifid}
                                        callBackOnClose={() => this.resetDataFromStoreOnCancel()}
                                        forceOpenPrem={createContractState && createContractState === CONTRACT_PRE_MANDATE ? true : false}
                                        moduleOptions={this.collectVariableValues()}
                                        ticketId={ticketId}
                                        ticketDocuments={ticketDocuments}
                                        selectedTicketDocuments={selectedTicketDocuments}
                                        emailAttachmentTicketDocuments={emailAttachmentTicketDocuments}
                                    />
                                </div>
                            }
                            <div>
                                <div className={styles.wizardButtonCorrection} >

                                    <ClaimWizardButton
                                        contractNumber={contract.contractNumber}
                                        contractId={contractIdForMifid}
                                        clientId={clientId}
                                        brokerNumber={brokerNumber}
                                        isClientContract={true}
                                        onCloseMethod={() => this.fetchData()}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {contract &&
                    <div className={styles.clientContractZoom}>
                        <div className={styles.moduleSection}>
                            <div className={styles.moduleSectionHeading}>
                                <h2 className={styles.subTitle}>{_('contractNumber')} <span>{contract.contractNumber}</span></h2>
                            </div>
                            <KeyValue array={columns} divider />
                        </div>
                        {details && details.risks && details.risks.length &&
                            <div className={styles.moduleSection}>
                                <div className={styles.moduleSectionHeading}>
                                    <h2 className={styles.subTitle}>{_('riskHeader')}</h2>
                                </div>
                                {details.risks.map((item, key) =>
                                    <Risk key={key} data={item} />
                                )}
                            </div>
                        }
                        {claims.length > 0 &&
                            <div className={styles.moduleSection}>
                                <Claims
                                    zoomTo={(claimId) => {
                                        dispatch(setClientSubModule('claims'))
                                        dispatch(setOpenedSubmenu(claimId))
                                    }} 
                                    data={claims}
                                />
                            </div>
                        }
                        {documents &&
                            <Uploader
                                type="contract"
                                documents={documents}
                                id={contract.contractId}
                                clientId={clientId}
                                forceState={uploadForceState}
                                forceDescription={uploadForceDescription}
                            />
                        }
                    </div>
                }
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./components/clients/clientContractsZoom.jsx